import classnames from 'classnames'

export type IconName =
  | 'alert'
  | 'calendar'
  | 'check-circle'
  | 'clock'
  | 'home'
  | 'info'
  | 'x-circle'
  | 'users'

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName
}

export default function Icon({ name, className, ...props }: IconProps) {
  const resolvedClassName = classnames('h-5 w-5', className)

  switch (name) {
    case 'alert':
      return (
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className={resolvedClassName}
          {...props}
        >
          <path d="M12 8v5" />
          <path d="M12 16.5h.01" />
          <path d="M10.3 3.8 3.9 15a2 2 0 0 0 1.7 3h12.8a2 2 0 0 0 1.7-3L13.7 3.8a2 2 0 0 0-3.4 0Z" />
        </svg>
      )
    case 'calendar':
      return (
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className={resolvedClassName}
          {...props}
        >
          <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
          <path d="M7.5 3.5v3M16.5 3.5v3M3.5 9.5h17" />
          <path d="M8 13h3M13 13h3M8 17h3" />
        </svg>
      )
    case 'check-circle':
      return (
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className={resolvedClassName}
          {...props}
        >
          <circle cx="12" cy="12" r="8.5" />
          <path d="m8.5 12.3 2.3 2.3 4.7-5" />
        </svg>
      )
    case 'clock':
      return (
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className={resolvedClassName}
          {...props}
        >
          <circle cx="12" cy="12" r="8.5" />
          <path d="M12 7.5v5l3 2" />
        </svg>
      )
    case 'home':
      return (
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className={resolvedClassName}
          {...props}
        >
          <path d="M3 10.5 12 3l9 7.5" />
          <path d="M5.5 9.5V20h13V9.5" />
          <path d="M10 20v-5h4v5" />
        </svg>
      )
    case 'info':
      return (
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className={resolvedClassName}
          {...props}
        >
          <circle cx="12" cy="12" r="8.5" />
          <path d="M12 10.5v4.5" />
          <path d="M12 8h.01" />
        </svg>
      )
    case 'x-circle':
      return (
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className={resolvedClassName}
          {...props}
        >
          <circle cx="12" cy="12" r="8.5" />
          <path d="m9 9 6 6" />
          <path d="m15 9-6 6" />
        </svg>
      )
    case 'users':
      return (
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className={resolvedClassName}
          {...props}
        >
          <path d="M15.5 19.5v-1a3.5 3.5 0 0 0-3.5-3.5h-3a3.5 3.5 0 0 0-3.5 3.5v1" />
          <circle cx="10.5" cy="8.5" r="3.5" />
          <path d="M18 18.5v-.5a3 3 0 0 0-2.2-2.9" />
          <path d="M15.5 5.6a3.5 3.5 0 0 1 0 5.8" />
        </svg>
      )
  }
}
